import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../config";
import "./NotificationStrip.css";

const NotificationStrip = () => {
  const [notification, setNotification] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    axios
      .get(`${config.apiUrl}/api/v1/notification`)
      .then(({ data }) => {
        if (!data.notification) return;
        const n = data.notification;
        const dismissed = localStorage.getItem(`notif_dismissed_${n._id}`);
        if (!dismissed) {
          setNotification(n);
          setVisible(true);
          document.documentElement.style.setProperty('--notif-h', '40px');
        }
      })
      .catch(() => {});
  }, []);

  const dismiss = () => {
    localStorage.setItem(`notif_dismissed_${notification._id}`, "1");
    setVisible(false);
    document.documentElement.style.setProperty('--notif-h', '0px');
  };

  if (!visible || !notification) return null;

  return (
    <div className="notif-strip">
      <span className="notif-text">
        {notification.link ? (
          <>
            {notification.message}{" "}
            <a
              href={notification.link}
              target="_blank"
              rel="noreferrer"
              className="notif-link"
            >
              Learn more →
            </a>
          </>
        ) : (
          notification.message
        )}
      </span>
      <button className="notif-dismiss" onClick={dismiss} aria-label="Dismiss">
        ×
      </button>
    </div>
  );
};

export default NotificationStrip;
